module.exports = __webpack_public_path__ + "img/blog-2.eaaf58e7.webp";